export class AuthenticationEmployeeError extends Error {
  readonly name: string

  readonly __proto__: AuthenticationEmployeeError

  constructor(message?: string) {
    const prototype = new.target.prototype
    super(message)
    this.__proto__ = prototype
    this.name = "AUTHENTICATION_EMPLOYEE_ERROR"
  }
}
